import { FeatureValue } from '../entities';
import { useFeatureFlags } from './useFeatureFlags';

export function useFeatureValue<T extends FeatureValue = FeatureValue>(featureName: string): T | null;
export function useFeatureValue<T extends FeatureValue = FeatureValue>(featureName: string, defaultValue: T): T;
export function useFeatureValue<T extends FeatureValue = FeatureValue>(
  featureName: string,
  defaultValue?: T,
): T | null {
  const { featureFlags } = useFeatureFlags();

  return featureFlags.getFeatureValue(featureName, defaultValue ?? null);
}
